var _excluded = ["children", "fluid", "className", "as"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "@xo-union/tk-css-grid/lib/styles.css";
var Container = function Container(_ref) {
  var children = _ref.children,
    fluid = _ref.fluid,
    className = _ref.className,
    ComponentToRender = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var containerClass = fluid && styles['container-fluid'];
  var completeClass = cx(containerClass, className);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    className: completeClass
  }, props), children);
};
process.env.NODE_ENV !== "production" ? Container.propTypes = {
  children: PropTypes.node,
  /**
   * Make grid fluid
   */
  fluid: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Component to render
   */
  as: PropTypes.elementType
} : void 0;
Container.defaultProps = {
  fluid: false,
  className: '',
  as: 'div'
};
export default Container;